module.exports = __webpack_public_path__ + "static/media/gcdef_10044.6d3bc411.ico";